/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import {
  Select,
  InputLabel,
  MenuItem,
  Checkbox,
  ListItemText,
  Input,
  IconButton,
} from '@material-ui/core';
import { Cached as CachedIcon } from '@material-ui/icons';

import { GET_TITLES_AS_CONTENTMANAGER } from 'queries/titleContent';
import { moment } from 'utils/momentConfig';
import Loading from '../Loading';
import useStyles from './styles';
// import { StatusType } from 'enums/status-type.enum';

interface ISelectTitlesToPresellProps {
  titlesToPresellIds: Array<string>;
  siteDomain: string;
  setTitlesToPresellIds: any;
}

const SelectTitlesToPresell: React.FC<ISelectTitlesToPresellProps> = ({
  titlesToPresellIds,
  siteDomain,
  setTitlesToPresellIds,
}) => {
  const classes = useStyles();

  const [contentTitlesFromApi, setContentTitlesFromApi] = useState<
    Array<ITitle>
  >([]);
  const [selectedTitles, setSelectedTitles] = useState<Array<any>>([]);

  const getInitialDateHelper = (addDaysValue: number) => {
    const date = moment().add(addDaysValue, 'days');
    const returnDate = moment(date).startOf('day').toDate();
    return returnDate;
  };

  const getEndDateHelper = (addDaysValue: number) => {
    const date = moment().add(addDaysValue, 'days');
    const returnDate = moment(date).endOf('day').toDate();
    return returnDate;
  };

  const last90DaysDatesFilter = {
    dateStart: getInitialDateHelper(-89),
    dateEnd: getEndDateHelper(0),
  };

  const [
    loadContentTitles,
    { data: contentTitlesData, loading: contentTitlesLoading },
  ] = useLazyQuery(GET_TITLES_AS_CONTENTMANAGER, {
    fetchPolicy: 'network-only',
  });

  const callLoadContentTitlesQuery = () => {
    loadContentTitles({
      variables: {
        sites: [siteDomain],
        // offset: 0 * 10,
        // limit: 10,
        dateStart: last90DaysDatesFilter.dateStart,
        dateEnd: last90DaysDatesFilter.dateEnd,
        // status: StatusType.Published,
      },
    });
  };

  const handleSelectChange = (event: React.ChangeEvent<any>) => {
    if (event.target.value) {
      setSelectedTitles(event.target.value);
      setTitlesToPresellIds(event.target.value);
    }
  };

  useEffect(() => {
    if (siteDomain) {
      callLoadContentTitlesQuery();
    }
  }, [siteDomain]);

  useEffect(() => {
    if (contentTitlesData) {
      const { titles } = contentTitlesData.titlesAsContentManager;

      if (titles && titles.length > 0) {
        if (titlesToPresellIds && titlesToPresellIds.length > 0) {
          setSelectedTitles(titlesToPresellIds);
        }

        setContentTitlesFromApi(titles);
      } else {
        setContentTitlesFromApi([]);
      }
    }
  }, [contentTitlesData]);

  const renderContentTitlesNamesInSelectLabel = (selectedValues: any) => {
    if (contentTitlesFromApi.length > 0) {
      const mappedSelectedContentTitles = selectedValues.map(
        (contentTitleId: string) => {
          return (
            contentTitlesFromApi.find(
              (contentTitleFromApi: ITitle) =>
                contentTitleFromApi.id === contentTitleId,
            )?.title || ''
          );
        },
      );
      return mappedSelectedContentTitles.join(', ');
    }

    return selectedValues.join(', ');
  };

  return (
    <>
      <Loading openLoading={contentTitlesLoading} />
      <div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
        <InputLabel className={classes.inputLabel} style={{ marginTop: 0 }}>
          Titles to Presell
        </InputLabel>
        <IconButton
          onClick={callLoadContentTitlesQuery}
          style={{ padding: 0, marginLeft: 4 }}
        >
          <CachedIcon fontSize="small" />
        </IconButton>
      </div>
      <Select
        fullWidth
        labelId="titlesToPresell"
        id="titlesToPresell"
        multiple
        value={selectedTitles}
        onChange={(ev) => handleSelectChange(ev)}
        input={<Input />}
        disabled={!siteDomain}
        renderValue={(selected) => renderContentTitlesNamesInSelectLabel(selected)}
        MenuProps={classes.menuProps as any}
      >
        {contentTitlesFromApi.map((contentTitle: ITitle) => (
          <MenuItem key={contentTitle.id} value={contentTitle.id}>
            <Checkbox checked={selectedTitles.indexOf(contentTitle.id) > -1} />
            <ListItemText primary={contentTitle.title} />
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default SelectTitlesToPresell;
